export type CatalogueFailure = Readonly<{
  kind: "security" | "rejected" | "unknown";
  message: string;
}>;

/** Never render a provider/server payload as user-facing copy. */
export function classifyCatalogueFailure(error: unknown): CatalogueFailure {
  const data = typeof error === "object" && error !== null && "data" in error ? error.data : null;
  const code = typeof data === "object" && data !== null && "code" in data ? data.code : null;
  if (
    typeof code === "string" &&
    [
      "AUTHENTICATION_REQUIRED",
      "AUTHORIZATION_DENIED",
      "MFA_REQUIRED",
      "REAUTHENTICATION_REQUIRED",
    ].includes(code)
  ) {
    return { kind: "security", message: "Verify your administrator access before continuing." };
  }
  if (code === "INVALID_INPUT")
    return {
      kind: "rejected",
      message:
        "The change was not saved. Check the wording, source links, review dates and publication window, then try again.",
    };
  if (
    typeof code === "string" &&
    ["STALE_REVISION", "CONFLICT", "NOT_FOUND", "REPLAY_MISMATCH"].includes(code)
  ) {
    return {
      kind: "rejected",
      message:
        "The change was rejected. Return to the catalogue and inspect the latest version before trying again.",
    };
  }
  return {
    kind: "unknown",
    message:
      "This change was not confirmed. Retry the same request before starting another change.",
  };
}
